import React from "react";
import classnames from "classnames";
import styles from "./switch.css";

interface SwitchProps {
    selected: boolean;
    disabled: boolean;
    onChange: (newState: boolean) => void;
}

export default function Switch({
    selected = false,
    disabled = false,
    onChange = (): void => {},
}: SwitchProps): JSX.Element {
    return (
        <div
            className={classnames(
                styles.toggle,
                { [styles.selected]: selected },
                { [styles.disabled]: disabled }
            )}
            onClick={(): void => {
                onChange(!selected);
            }}
        >
            <div className={styles.toggleButton} />
        </div>
    );
}
